import { render, staticRenderFns } from "./PaymentMethodIcon.vue?vue&type=template&id=6668f556&scoped=true&"
import script from "./PaymentMethodIcon.vue?vue&type=script&lang=ts&"
export * from "./PaymentMethodIcon.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentMethodIcon.vue?vue&type=style&index=0&id=6668f556&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6668f556",
  null
  
)

export default component.exports